<div class="trivial-names-container">
  <div class="trivial-names-item-container">
    <div class="trivial-names-item-input-container">
      <mat-form-field appearance="outline" class="trivial-names-form-field">
        <mat-label>Trivial name(s)</mat-label>
        <input matInput #trivialNamesInput [(ngModel)]="trivialNames" class="trivial-names trivial-names-item-input"
          (keyup.enter)="updateTrivialNames($event)" (keyup.escape)="cancelUpdate()" (blur)="updateTrivialNames($event)" />
        <mat-icon matSuffix (mousedown)="clearTrivialNamesInputField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>
 <!--  <div *ngIf="formType ==='FormC'" class="trivial-names-info trivial-names-info-text">
    Include any changes or additions since the first USAN was adopted.
  </div> -->
   <div class="trivial-names-info trivial-names-info-text">
   The USAN Council should be notified of any trivial names used in journals prior to establishing a nonproprietary name or trademark.
  </div>
</div>